export default [
    {name: 'home', ref: "#headerSection"},
    // {name: 'about', ref: "#aboutSection"},
    {name: 'features', ref: "#featuresSection"},
    {name: 'stats', ref: "#statsSection"},
    {name: 'clients', ref: "#clientsSection"},
    {name: 'partners', ref: "#partnersSection"},
    // {name: 'timeline', ref: "#timelineSection"},
    {name: 'contact', ref: "#contactSection"}
]